module.exports = __webpack_public_path__ + "static/img/4.b085e95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cs/4.jpg
// module id = Ji79
// module chunks = 1